import * as React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { BLOCKS } from '@contentful/rich-text-types';

import AccordionItem from '@components/sections/AccordionItem/index';
import BoxWithNumbers from '@components/blog/BoxWithNumbers';
import KeywordsSection from '@components/blog/KeywordsSection';
import PlayGridItems from '@components/PlaysAndPlaybooks/PlayGridItems';
import PlaySubscribe from '@components/PlaysAndPlaybooks/PlaySubscribe';
import PostAd from '@components/blog/PostAd';
import PostImage from '@components/blog/PostImage';
import Quote from '@components/sections/Quote/indexCompose';
import TipSection from '@components/blog/TipSection';
import Youtube from '@components/Youtube';

import * as styles from './style.module.scss';
const { accordionItem__img } = styles;

const renderNode = (type, data) => {
  switch (type) {
    case 'subscribe':
      return (
        <PlaySubscribe
          formIdEN={data.formIdEn}
          formIdDe={data.formIdDe}
          formTitleEN={data.formTitleEn}
          formTitleDE={data.formTitleDe}
        />
      );
    case 'playgrid':
      return <PlayGridItems posts={data?.plays} />;
    case 'accordion':
      return (
        <AccordionItem
          content={{
            heading: data.title,
            accordionData: data.accordionItems,
          }}
        />
      );
    case 'video':
      return <Youtube videoId={data.videoId} modifier={'blog'} />;
    case 'ad':
      return <PostAd content={data} />;
    case 'image':
      return <PostImage content={data} />;
    case 'tip':
      return <TipSection content={data} />;
    case 'iframe':
      return (
        <iframe
          id="inlineFrameExample"
          title=""
          width="700"
          height="400"
          src={data.url}
        ></iframe>
      );
    case 'boxwithnumbers':
      return <BoxWithNumbers content={data} />;
    case 'keywords-section':
      return <KeywordsSection content={data} />;
    case 'quote':
      return (
        <Quote
          key={data.index}
          text={data.quoteText.internal.content}
          icon={data.icon?.svg.originalContent}
          author={{
            name: data.authorName,
            position: data.authorPosition,
            avatar: data.authorProfilePicture,
          }}
          type={data.type}
        />
      );
    default:
      return null;
  }
};

export const renderOptions = (references) => ({
  renderNode: {
    [BLOCKS.EMBEDDED_ENTRY]: (node) => {
      const nodeId = node.data.target.sys.id;
      const data = Array.isArray(references) && references.find((item) => item.contentful_id === nodeId) || {};
      const type = data.type;

      return renderNode(type, data);
    },
    [BLOCKS.HEADING_2]: (node) => {
      return <h2>{node.content[0].value}</h2>;
    },
    [BLOCKS.EMBEDDED_ASSET]: (node) => {
      const nodeId = node.data.target.sys.id;
      const data = Array.isArray(references) && references.find((item) => item.contentful_id === nodeId) || {};

      if (!data.gatsbyImageData) {
        console.warn('Missing gatsbyImageData for asset:', nodeId);
        return null; // Skip rendering if asset data is missing
      }

      const img = getImage(data.gatsbyImageData);
      return (
        <GatsbyImage
          className={accordionItem__img}
          quality={100}
          image={img}
          alt={data.description}
        />
      );
    },
  },
});
